import React, { useState, useEffect } from "react";
import { Maximize, UploadCloud, Expand } from "lucide-react";
import DocumentPreview from "../../Create-Investment/documentpreview";
import { useDispatch, useSelector } from "react-redux";
import { clearCurrentStep } from "../../../Redux/store/onboardingFormSlice";

const ReviewSubmit = ({ setCurrentStep }) => {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const formData = useSelector((state) => state.form.formData);
  const [firstName, setFirstName] = useState("John");
  const [profilePic, setProfilePic] = useState("/avatar.svg");
  const [lastName, setLastName] = useState("Mayer");
  const [email, setEmail] = useState("mayer@gmail.com");
  const [otherActivity, setOtherActivity] = useState("");
  const [mobileNumber, setMobileNumber] = useState("+61 6 7898 7298");
  const [customerType, setCustomerType] = useState("+61 6 7898 7298");
  const [advisorRefNumber, setAdvisorRefNumber] = useState(
    "99834 (Brian	Vaughan)"
  );
  const [typeOfAccount, setTypeOfAccount] = useState(
    "Customer with joint account between a husband and wife with same address"
  );
  const [fullName, setFullName] = useState("John Mayer");
  const [formerNames, setFormerNames] = useState("John Mayer");
  const [dob, setDob] = useState("4/5/1988");
  const [redAddress, setRedAddress] = useState(
    "122NC Cross Road, Main City Melbourne"
  );
  const [ownership, setOwnership] = useState("");

  const [applicantCountryText, setApplicantCountryText] = useState("Australia");
  const [clientNo, setClientNo] = useState("CM0013189P");
  const [jointAccountID, setJointAccountID] = useState("CM0013189P");
  const [expectedAmount, setExpectedAmount] = useState("$50 - $100 million");
  const [investmentCurrency, setInvestmentCurrency] = useState("AUD");
  const [signatory, setSignatory] = useState("yes");
  const [thirdPartySign, setThirdPartySign] = useState("yes");
  const [jointAccountName, setJointAccountName] = useState("");
  const [fileAttorney, setFileAttorney] = useState(null);
  const [taxResidentCountry, setTaxResidentCountry] = useState(1);
  const [taxResidentCountryText, setTaxResidentCountryText] = useState("US");
  const [businessNature, setBusinessNature] = useState(null);
  const [businessNatureText, setBusinessNatureText] = useState("");
  const [nonResCountry, setNonResCountry] = useState(null);
  const [nonResCountryText, setNonResCountryText] = useState("");
  const [socialSecurityNumber, setSocialSecurityNumber] = useState("");
  const [taxId, setTaxId] = useState("");
  const [abn, setAbn] = useState("");
  const [businessRegistrationNumber, setBusinessRegistrationNumber] =
    useState("ACB2231");
  const [businessAddress, setBusinessAddress] = useState("");
  const [businessName, setBusinessName] = useState("");
  const [businessActivity, setBusinessActivity] = useState("smaple text");
  const [businessActivityText, setBusinessActivityText] =
    useState("smaple text");
  const [fundSource, setFundSource] = useState("smaple text");
  const [transactionNature, setTransactionNature] = useState("");
  const [caprockFund, setCaprockFund] = useState("smaple text");
  const [image, setImage] = useState("/avatar.svg");
  const [fullscreen, setFullscreen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isConfirmWithdraw, setIsConfirmWithdraw] = useState(false);
  const [isConfirmSubmit, setIsConfirmSubmit] = useState(false);
  const [currentDocument, setcurrentDocument] = useState({});
  const [fileThirdParty, setFileThirdParty] = useState(null);
  const [description, setDescription] = useState("testing 1 2 3");
  const [fileProof, setFileProof] = useState(null);
  const [jointAccountMembers, setJointAccountMembers] = useState([]);
  const [applicantCountry, setApplicantCountry] = useState(null);
  const [accountType, setAccountType] = useState(null);
  const secondheaders = [
    "",
    "Full Name",
    "Date Of Birth",
    "Email Address",
    "Mobile Number",
    "Account Type",
  ];
  const secondheadersWithAddress = [
    "",
    "First Name",
    "Last Name",
    "Email Address",
    "Mobile Number",
    "Residential Address",
    "Account Type",
  ];
  const [bankdata, setBankdata] = useState([]);
  const [accountCount, setAccountCount] = useState(7);
  const [photoIdText, setPhotoIdText] = useState("John");
  const [nonphotoIdText, setNonPhotoIdText] = useState("John");
  const [nonphotoId, setNonPhotoId] = useState(null);
  const [photoId, setphotoId] = useState(1);
  const [filePhotographicId, setFilePhotographicId] = useState(null);
  const [fileDriverLinsenceFront, setFileDriverLinsenceFront] = useState(null);
  const [fileDriverLinsenceBack, setFileDriverLinsenceBack] = useState(null);
  const [expiryDate, setExpiryDate] = useState("02/12/2026");
  const [expiryDateSecond, setExpiryDateSecond] = useState("");
  const [photoIdFirst, setphotoIdFirst] = useState(1);
  const [photoIdFirstText, setphotoIdFirstText] = useState("");
  const [photoIdSecondText, setphotoIdSecondText] = useState("");
  const [photoIdSecond, setphotoIdSecond] = useState(2);

  const [filePhotographicIdFirst, setfilePhotographicIdFirst] = useState(null);
  const [fileDriverLinsenceFrontFirst, setFileDriverLinsenceFrontFirst] =
    useState(null);
  const [fileDriverLinsenceBackFirst, setFileDriverLinsenceBackFirst] =
    useState(null);
  const [fileDriverLinsenceBackSecond, setFileDriverLinsenceBackSecond] =
    useState(null);
  const [filePhotographicIdSecond, setfilePhotographicIdSecond] =
    useState(null);
  const [fileDriverLinsenceFrontSecond, setFileDriverLinsenceFrontSecond] =
    useState(null);
  const [fileNonPhotographicId, setfileNonPhotographicId] = useState(null);
  const [personalDataId, setPersonalDataId] = useState(1);
  const [personalDataIdText, setPersonalDataIdText] = useState("");
  const [fileCV, setFileCV] = useState(null);
  const [webLink, setWebLink] = useState("");
  const [accounts, setAccounts] = useState([]);
  const handleFileClick = (docData) => {
    setcurrentDocument(docData);
    setIsModalOpen(true);
  };
  const setReviewFields = () => {
    setCustomerType(formData.accountTypeLabel);
    setProfilePic(formData.profilePic);
    setAdvisorRefNumber(formData.advisorRefNumber);
    setTypeOfAccount(formData.accountTypeLabel);
    setFullName(formData.fullName);
    setFormerNames(formData.customerFormerNames);
    setDob(formData.dob);
    setRedAddress(formData.address);
    setApplicantCountryText(formData.applicantCountryText);
    setApplicantCountry(formData.applicantCountry);
    setClientNo(formData.clientNo);
    setAccountType(formData.accountType);
    setExpectedAmount(formData.expectedInvestedAmount);
    setInvestmentCurrency(formData.currency);
    // Joint Account
    if (formData.accountType != 1 && formData.accountType != 5) {
      setJointAccountID(formData.jointAccountId);
      //  setJointAccountMembers(formData.jointAccountMember);
      setJointAccountMembers([]);
      setSignatory(formData.isSignatory);
      setJointAccountName(formData.jointAccountUserLabel);
      setFileAttorney(formData.fileAttorney);
    }
    // Business section
    setTaxResidentCountryText(formData.citizenTypeText);
    setTaxResidentCountry(formData.citizenType);
    setBusinessAddress(formData.businessAddress);
    setBusinessName(formData.businessName);
    if (formData.citizenType == 1 && formData.accountType == 5) {
      setAbn(formData.abn);
    }
    if (formData.citizenType == 2) {
      setNonResCountryText(formData.nonResCountryText);
      setNonResCountry(formData.nonResCountry);
    }
    if (formData.citizenType == 3) {
      setSocialSecurityNumber(formData.socialSecurityNumber);
      setTaxId(formData.taxId);
    }
    setBusinessNature(formData.businessNature);
    setBusinessNatureText(formData.businessNatureText);
    setBusinessRegistrationNumber(formData.businessRegNum);
    setBusinessActivity(formData.businessActivity);
    setBusinessActivityText(formData.businessActivityText);
    setOtherActivity(formData.otherActivity);
    setFundSource(formData.fundingSource);
    setTransactionNature(formData.transactionLevel);
    setOwnership(formData.ownership);
    // setImage(URL.createObjectURL(formData.proofFile));
    // setBankdata(formData.bankdata);
    //  setAccounts(formData.userAccounts);
    setFileThirdParty(formData.fileThirdParty);
    setThirdPartySign(formData.thirdPartySign);
    setDescription(formData.description);
    setFileProof(formData.fileProof);
    setExpiryDate(formData.expiryDate);
    if (
      formData.applicantCountry == 1 &&
      (formData.accountType == 1 || formData.accountType == 5)
    ) {
      setPhotoIdText(formData.photoIdText);
      setphotoId(formData.photoId);
      if (formData.photoId == 1 || formData.photoId == 3) {
        setFilePhotographicId(formData.filePhotographicId);
      }
      if (formData.photoId == 2) {
        setFileDriverLinsenceFront(formData.fileDriverLinsenceFront);
        setFileDriverLinsenceBack(formData.fileDriverLinsenceBack);
      }
    }
    if (
      formData.applicantCountry != 1 &&
      (formData.accountType == 1 || formData.accountType == 5)
    ) {
      setphotoIdFirst(formData.photoIdFirst);
      setphotoIdFirstText(formData.photoIdFirstText);
      setphotoIdSecond(formData.photoIdSecond);
      setphotoIdSecondText(formData.photoIdSecondText);
      setExpiryDateSecond(formData.expiryDateSecond);
      if (formData.photoIdFirst == 1 || formData.photoIdFirst == 3) {
        setfilePhotographicIdFirst(formData.filePhotographicIdFirst);
      }
      if (formData.photoIdFirst == 2) {
        setFileDriverLinsenceFrontFirst(formData.fileDriverLinsenceFrontFirst);
        setFileDriverLinsenceBackFirst(formData.fileDriverLinsenceBackFirst);
      }
      if (formData.photoIdSecond == 1 || formData.photoIdSecond == 3) {
        setfilePhotographicIdSecond(formData.filePhotographicIdSecond);
      }
      if (formData.photoIdSecond == 2) {
        setFileDriverLinsenceFrontSecond(
          formData.fileDriverLinsenceFrontSecond
        );
        setFileDriverLinsenceBackSecond(formData.fileDriverLinsenceBackSecond);
      }
    }
    setNonPhotoIdText(formData.nonphotoIdText);
    setNonPhotoId(formData.nonphotoId);
    setfileNonPhotographicId(formData.fileNonPhotographicId);
    setPersonalDataIdText(formData.personalDataIdText);
    setPersonalDataId(formData.personalDataId);
    setFileCV(formData.fileCV);
    setWebLink(formData.webLink);
  };
  useEffect(() => {
    if (formData) {
      setReviewFields();
      dispatch(clearCurrentStep());
    }
  }, [formData]);
  return (
    <div className="flex flex-col min-h-[calc(100vh-100px)] lg:min-w-[80vw] lg:max-w-[80vw]">
      <div className="flex-grow overflow-visible">
        {loading && (
          <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
            <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
          </div>
        )}
        <div className="bg-white shadow-md rounded-md p-4">
          <div className="border-b border-colour-custom pb-2">
            <div className="flex items-center space-x-2 mb-2">
              <img src="/note-2.svg" alt="User Avatar" className="h-6 w-6" />
              <h1 className="text-xl font-medium">
                Review And submit your information
              </h1>
            </div>
          </div>
          <div className="bg-white border rounded-md p-4 mt-2">
            <div className="flex items-center border-colour-custom space-x-2 px-4">
              <img
                src="/profile-circle-black.svg"
                alt="User Avatar"
                className="h-6 w-6 mb-2"
              />
              <h1 className="text-xl font-medium mb-2">
                Open Account Information
              </h1>
            </div>

            <div className="bg-white">
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                <div className="flex flex-col px-4 pt-4">
                  <label
                    htmlFor="firstName"
                    className="mb-1 text-sm text-labelColour"
                  >
                    First Name
                  </label>
                  <span>{firstName}</span>
                  <label
                    htmlFor="firstName"
                    className="mb-1 mt-4 text-sm text-labelColour"
                  >
                    Last Name
                  </label>
                  <span>{lastName}</span>
                </div>
                <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                  <label
                    htmlFor="email"
                    className="mb-1 text-sm text-labelColour"
                  >
                    Email
                  </label>
                  <span>{email}</span>
                  <label
                    htmlFor="firstName"
                    className="mb-1 mt-4 text-sm text-labelColour"
                  >
                    Mobile Number
                  </label>
                  <span>{mobileNumber}</span>
                </div>
                <div className="flex lg:pt-4 pt-0 flex-col px-4">
                  <label
                    htmlFor="customerType"
                    className="mb-1 text-sm text-labelColour"
                  >
                    Customer Type
                  </label>
                  <span>{customerType}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white border rounded-md p-4 mt-4">
            <div className="flex justify-between items-start border-colour-custom px-4">
              {/* Left Section: Icon + Heading */}
              <div className="flex items-center space-x-2">
                <img
                  src="/profile-circle-black.svg"
                  alt="User Avatar"
                  className="h-6 w-6"
                />
                <h1 className="text-xl font-medium">Personal Information</h1>
              </div>

              {/* Right Section: Edit Button */}
              <img
                onClick={(e) => {
                  e.preventDefault();
                  setCurrentStep(1);
                }}
                src="/edit-details.svg"
                alt="Edit Icon"
                className="w-4 h-4 cursor-pointer"
              />
            </div>
            <div className="bg-white border-b pb-4">
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                <div className="flex flex-col px-4 pt-4">
                  <label
                    htmlFor="firstName"
                    className="mb-1 text-sm text-labelColour"
                  >
                    Profile Picture
                  </label>
                  <div className="relative flex-shrink-0 mb-4 lg:mb-0 mt-1 mr-6">
                    <img
                      src={profilePic}
                      alt={`${firstName}`}
                      className="w-20 h-20 rounded-full object-cover"
                    />
                  </div>
                  <label
                    htmlFor="advisorRefNumber"
                    className="mb-1 mt-4 text-sm text-labelColour"
                  >
                    Advisor Ref No
                  </label>
                  <span>{advisorRefNumber}</span>
                  <label
                    htmlFor="TypeOfCustomer"
                    className="mb-1 mt-4 text-sm text-labelColour"
                  >
                    Type Of Individual Customer
                  </label>
                  <span>{typeOfAccount}</span>
                </div>
                <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                  <label
                    htmlFor="fullName"
                    className="mb-1 text-sm text-labelColour"
                  >
                    Full Name
                  </label>
                  <span>{fullName}</span>
                  <label
                    htmlFor="formerNames"
                    className="mb-1 mt-4 text-sm text-labelColour"
                  >
                    Customer's Former Name(s)
                  </label>
                  <span>{formerNames}</span>
                  <label
                    htmlFor="dob"
                    className="mb-1 mt-4 text-sm text-labelColour"
                  >
                    Date of Birth
                  </label>
                  <span>{dob}</span>
                  <label
                    htmlFor="redAddress"
                    className="mb-1 mt-4 text-sm text-labelColour"
                  >
                    Residential Address
                  </label>
                  <span>{redAddress}</span>
                  <label
                    htmlFor="redAddress"
                    className="mb-1 mt-4 text-sm text-labelColour"
                  >
                    Applicant's Country
                  </label>
                  <span>{applicantCountryText}</span>
                </div>
                <div className="flex lg:pt-4 pt-0 flex-col pr-4">
                  <label
                    htmlFor="clientNo"
                    className="mb-1 text-sm text-labelColour"
                  >
                    Client No
                  </label>
                  <span>{clientNo}</span>
                  <label
                    htmlFor="expectedAmount"
                    className="mt-4 mb-1 text-sm text-labelColour"
                  >
                    Expected Investment Amount
                  </label>
                  <span>{expectedAmount}</span>
                  <label
                    htmlFor="expectedAmount"
                    className="mt-4 mb-1 text-sm text-labelColour"
                  >
                    Default Investment Currency
                  </label>
                  <span>{investmentCurrency}</span>
                  {accountType != 1 && accountType != 5 && (
                    <>
                      <label
                        htmlFor="jointAccountID"
                        className="mt-4 mb-1 text-sm text-labelColour"
                      >
                        Joint Account ID
                      </label>
                      <span>{jointAccountID}</span>
                    </>
                  )}
                </div>
              </div>
            </div>
            {accountType != 1 && accountType != 5 && (
              <div className="bg-white mt-4">
                <div className="flex items-center border-b border-colour-custom space-x-2 px-4">
                  <h1 className="text-xl font-medium mb-2">
                    Joint Account Members
                  </h1>
                </div>
                <div className="overflow-x-auto border-b mb-4">
                  <table className="table-auto w-full h-full border-separate pb-4 pt-4 border-[#EDEDED]  border-spacing-y-2 ">
                    {/* Table Header */}
                    <thead className="text-[#8C8C8C]  rounded-md mb-2 text-sm">
                      {accountType != 4 && (
                        <tr className="border border-[#EDEDED]">
                          {secondheaders.map((header, index) => (
                            <th
                              key={header}
                              className={`
                            cursor-pointer font-medium px-4 py-2 mb-5  text-left
                                        ${index === 0 ? "w-[50px]" : "w-auto"}

                            ${
                              index === 0
                                ? "border-t rounded-tl-md rounded-bl-md border-b border-l border-[#EDEDED]" // Center column: Top and Bottom border only
                                : ""
                            }
                                ${
                                  index === 1 ||
                                  index === 2 ||
                                  index === 3 ||
                                  index === 4
                                    ? "border-t border-b  border-[#EDEDED]" // Center column: Top and Bottom border only
                                    : ""
                                }
                              ${
                                index === 5
                                  ? "border-t border-b rounded-tr-md rounded-br-md border-r  border-[#EDEDED]" // Center column: Top and Bottom border only
                                  : ""
                              }
                          `}
                            >
                              <div class="flex items-center">
                                <span>{header}</span>
                              </div>
                            </th>
                          ))}
                        </tr>
                      )}
                      {accountType == 4 && (
                        <tr className="border border-[#EDEDED]">
                          {secondheadersWithAddress.map((header, index) => (
                            <th
                              key={header}
                              className={`
                            cursor-pointer font-medium px-4 py-2 mb-5  text-left
                                        ${index === 0 ? "w-[50px]" : "w-auto"}

                            ${
                              index === 0
                                ? "border-t rounded-tl-md rounded-bl-md border-b border-l border-[#EDEDED]" // Center column: Top and Bottom border only
                                : ""
                            }
                                ${
                                  index === 1 ||
                                  index === 2 ||
                                  index === 3 ||
                                  index === 4 ||
                                  index === 5
                                    ? "border-t border-b  border-[#EDEDED]" // Center column: Top and Bottom border only
                                    : ""
                                }
                              ${
                                index === 6
                                  ? "border-t border-b rounded-tr-md rounded-br-md border-r  border-[#EDEDED]" // Center column: Top and Bottom border only
                                  : ""
                              }
                          `}
                            >
                              <div class="flex items-center">
                                <span>{header}</span>
                              </div>
                            </th>
                          ))}
                        </tr>
                      )}
                    </thead>

                    {/* Table Body */}
                    <tbody className="text-sm mt-6  font-medium text-black">
                      {jointAccountMembers.length > 0 ? (
                        jointAccountMembers.map((member, idx) => (
                          <tr key={idx} className="mb-2 bg-[#F9F9F9]">
                            <td className="px-4 py-4 w-1 text-ellipsis  overflow-hidden whitespace-nowrap">
                              {(idx + 1).toString().padStart(2, "0")}.
                            </td>
                            <td className="px-4 py-4 text-ellipsis  overflow-hidden whitespace-nowrap">
                              {member.firstName}
                            </td>

                            {/* Dropdown Button */}
                            <td className="px-4 py-4 relative">
                              <input
                                type="date"
                                className="border w-full p-2 rounded-xl text-sm"
                                placeholder="Date of Birth"
                                value={member.dob}
                                disabled={true}
                              />
                            </td>

                            <td className="px-4 py-4 text-ellipsis  overflow-hidden whitespace-nowrap">
                              {member.email}
                            </td>
                            <td className="px-4 py-4 text-left text-ellipsis  overflow-hidden whitespace-nowrap">
                              <span className="text-[#888888]">
                                {member.countryCode}{" "}
                              </span>
                              {member.mobile}
                            </td>
                            {accountType == 4 && (
                              <td className="px-4 py-4 text-ellipsis  overflow-hidden whitespace-nowrap">
                                {member.address}
                              </td>
                            )}
                            <td className="px-4 py-4 text-ellipsis  overflow-hidden whitespace-nowrap">
                              {member.accountType == "individual"
                                ? "Individual"
                                : "Corporate"}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td className="text-center py-4" colSpan="7">
                            No results found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                <div className="mt-4 border-t grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                  <div className="flex flex-col px-2 md:pl-4 md:pr-0 pt-4">
                    {/* Label and Question */}
                    <div className="flex flex-col md:flex-col md:items-left md:justify-between gap-2">
                      <label
                        htmlFor="investmentType"
                        className="block text-sm text-labelColour whitespace-normal break-words"
                      >
                        Is there going to be a Sole Signatory by providing a
                        Power Of Attorney?
                        <span className="text-red-500">*</span>
                      </label>

                      {/* Radio Buttons */}
                      <div className="flex items-center gap-4 opacity-50 ">
                        <label className="flex items-center text-sm text-black">
                          <input
                            type="radio"
                            name="signatory"
                            value="yes"
                            checked={signatory === "yes"}
                            className="w-4 h-4 confirm-check  border-gray-300 focus:ring-[#005a9c]"
                          />
                          <span className="ml-2">Yes</span>
                        </label>

                        <label className="flex items-center text-sm text-black">
                          <input
                            type="radio"
                            name="signatory"
                            value="no"
                            checked={signatory === "no"}
                            className="w-4 h-4 confirm-check  border-gray-300 focus:ring-[#005a9c]"
                          />
                          <span className="ml-2">No</span>
                        </label>
                      </div>
                    </div>
                  </div>
                  {signatory == "yes" && (
                    <>
                      <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-2">
                        <div className="flex flex-col md:flex-col md:items-left md:justify-between gap-2">
                          <label
                            htmlFor="jointAccountName"
                            className="mb-1 text-sm text-labelColour whitespace-normal break-words block"
                          >
                            Select which joint account members are going to be
                            the signatories
                          </label>
                          <span>{jointAccountName}</span>
                        </div>
                      </div>
                      <div className="flex lg:pt-4 pt-0 flex-col px-2">
                        <div className="flex items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="text-sm text-labelColour flex items-center"
                          >
                            Power of Attorney
                            <span className="text-red-500">*</span>
                          </label>
                        </div>
                        {fileAttorney && (
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              handleFileClick(fileAttorney);
                            }}
                            className="cursor-pointer mt-2 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                          >
                            <div className="flex-col flex">
                              <span className="text-black">
                                {fileAttorney.name}
                              </span>
                            </div>
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
            )}
          </div>
          <div className="bg-white border rounded-md p-4 mt-4">
            <div className="flex justify-between items-start border-colour-custom px-4">
              {/* Left Section: Icon + Heading */}
              <div className="flex items-center space-x-2">
                <img
                  src="/buildings.svg"
                  alt="User Avatar"
                  className="h-6 w-6"
                />
                <h1 className="text-xl font-medium">Business Information</h1>
              </div>

              {/* Right Section: Edit Button */}
              <img
                onClick={(e) => {
                  e.preventDefault();
                  setCurrentStep(2);
                }}
                src="/edit-details.svg"
                alt="Edit Icon"
                className="w-4 h-4 cursor-pointer"
              />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
              <div className="flex flex-col px-4 pt-4">
                <label
                  htmlFor="applicantCountry"
                  className="mb-1 text-sm text-labelColour"
                >
                  Tax Resident Country
                </label>
                <span>{taxResidentCountryText}</span>
                {taxResidentCountry == 2 && (
                  <>
                    <label
                      htmlFor="country"
                      className="mb-1 mt-4 text-sm text-labelColour"
                    >
                      Country
                    </label>
                    <span>{nonResCountryText}</span>
                  </>
                )}

                <label
                  htmlFor="businessNature"
                  className="mb-1 mt-4 text-sm text-labelColour"
                >
                  Business Nature
                </label>
                <span>{businessNatureText}</span>
                {(taxResidentCountry == 2 ||
                  taxResidentCountry == 3 ||
                  (taxResidentCountry == 1 && accountType != 5)) && (
                  <>
                    <label
                      htmlFor="country"
                      className="mb-1 mt-4 text-sm text-labelColour"
                    >
                      Business Registration Number
                    </label>
                    <span>{businessRegistrationNumber}</span>
                  </>
                )}
                {taxResidentCountry == 3 && (
                  <>
                    <label
                      htmlFor="country"
                      className="mb-1 mt-4 text-sm text-labelColour"
                    >
                      Social Security Number
                    </label>
                    <span>{socialSecurityNumber}</span>
                  </>
                )}
                {taxResidentCountry == 1 && accountType == 5 && (
                  <>
                    <label
                      htmlFor="abn"
                      className="mb-1 mt-4 text-sm text-labelColour"
                    >
                      ABN
                    </label>
                    <span>{abn}</span>
                  </>
                )}
              </div>
              <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                <label
                  htmlFor="businessName"
                  className="mb-1 text-sm text-labelColour"
                >
                  Business Name
                </label>
                <span>{businessName}</span>
                <label
                  htmlFor="businessAddress"
                  className="mb-1 mt-4 text-sm text-labelColour"
                >
                  Address of Principal Place of Business
                </label>
                <span>{businessAddress}</span>
                <label
                  htmlFor="businessAddress"
                  className="mb-1 mt-4 text-sm text-labelColour"
                >
                  Describe the business activity
                </label>
                <span>{businessActivityText}</span>
                {businessActivity == 6 && (
                  <>
                    <label
                      htmlFor="businessAddress"
                      className="mb-1 mt-4 text-sm text-labelColour"
                    >
                      Please mention business activity
                    </label>
                    <span>{otherActivity}</span>
                  </>
                )}
                <label
                  htmlFor="businessAddress"
                  className="mb-1 mt-4 text-sm text-labelColour"
                >
                  Source of the funds including its origin
                </label>
                <span>{fundSource}</span>
              </div>
              <div className="flex lg:pt-4 pt-0 flex-col pr-4">
                <>
                  <label
                    htmlFor="applicantCountry"
                    className="mb-1 text-sm text-labelColour break-words"
                  >
                    Nature and level of the intended transaction behaviour
                  </label>
                  <span>{transactionNature}</span>
                  <label
                    htmlFor="applicantCountry"
                    className="mb-1 mt-4 text-sm text-labelColour"
                  >
                    Beneficial ownership of the funds used by this account with
                    Caprock
                  </label>
                  <span>{ownership}</span>
                </>
                {taxResidentCountry == 3 && (
                  <>
                    <label
                      htmlFor="country"
                      className="mb-1 mt-4 text-sm text-labelColour"
                    >
                      Tax ID
                    </label>
                    <span>{taxId}</span>
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="bg-white border rounded-md p-4 mt-4">
            <div className="flex justify-between items-start border-colour-custom px-4">
              {/* Left Section: Icon + Heading */}
              <div className="flex items-center space-x-2">
                <img src="/camera.svg" alt="User Avatar" className="h-6 w-6" />
                <h1 className="text-xl font-medium">Prove Its You</h1>
              </div>

              {/* Right Section: Edit Button */}
              <img
                onClick={(e) => {
                  e.preventDefault();
                  setCurrentStep(3);
                }}
                src="/edit-details.svg"
                alt="Edit Icon"
                className="w-4 h-4 cursor-pointer"
              />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
              <div className="flex flex-col px-4">
                <div>
                  <span className="text-sm text-[#A6A6A6]">Photo Upload</span>

                  <div className="mt-2 relative w-full max-w-[240px] h-40  rounded-md overflow-hidden">
                    {/* Uploaded Image */}
                    <img
                      src={image}
                      alt="Uploaded"
                      className="w-full h-full object-cover"
                    />

                    {/* Fullscreen Button */}
                    <button
                      onClick={() => setFullscreen(true)}
                      className="absolute top-2 right-2 "
                    >
                      <img
                        src="/show-full.svg"
                        alt="Full Screen"
                        className="w-5 h-5 text-white"
                      />
                    </button>
                  </div>
                </div>
              </div>
              {fullscreen && (
                <div
                  className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 px-4 py-6"
                  onClick={() => setFullscreen(false)}
                >
                  <img
                    src={image}
                    alt="Fullscreen"
                    className="max-w-full max-h-full object-contain rounded-md shadow-lg"
                  />
                </div>
              )}
            </div>
          </div>
          <div className="bg-white border rounded-md p-4 mt-4">
            <div className="flex justify-between items-start border-colour-custom px-4">
              {/* Left Section: Icon + Heading */}
              <div className="flex items-center space-x-2">
                <img src="/cards.svg" alt="User Avatar" className="h-6 w-6" />
                <h1 className="text-xl font-medium">
                  Connect External Account
                </h1>
              </div>

              {/* Right Section: Edit Button */}
              <img
                onClick={(e) => {
                  e.preventDefault();
                  setCurrentStep(4);
                }}
                src="/edit-details.svg"
                alt="Edit Icon"
                className="w-4 h-4 cursor-pointer"
              />
            </div>
            {bankdata.map((bank, index) => (
              <div className="relative flex flex-col lg:flex-row items-start lg:items-center lg:space-x-6 mb-6 border rounded-md">
                {/* Toggle Button on Top Right */}
                <div className="absolute top-2 pb-4 right-4 flex items-center space-x-2">
                  {!bank.isDefault && (
                    <button className="font-semibold border-2 border-[#005A9C] text-[#005A9C] text-[12px] px-3 py-1 rounded-full bg-[#005A9C] bg-opacity-20">
                      MAKE DEFAULT
                    </button>
                  )}
                  {bank.isDefault && (
                    <button className="font-semibold border-2 border-[#34C046] text-[#34C046] text-[12px] px-3 py-1 rounded-full bg-[#34C046] bg-opacity-20">
                      DEFAULT
                    </button>
                  )}
                </div>

                <div className="grid grid-cols-1 mt-4 sm:grid-cols-2 md:grid-cols-4 gap-6 w-full pt-6 pr-6">
                  {/* Column 1 */}
                  <div className="flex flex-col md:px-4 md:pt-6">
                    <label
                      htmlFor="refId"
                      className="mb-1 text-xs text-labelColour"
                    >
                      {index + 1}. Account Holder Name
                    </label>
                    <span className="text-sm">{bank.account_name}</span>
                    <div className="mt-4">
                      <label
                        htmlFor="investmentType"
                        className="mb-1 text-xs text-labelColour"
                      >
                        Account Number or IBAN
                      </label>
                      <div className="text-sm">{bank.account_number}</div>
                    </div>
                    <label
                      htmlFor="investmentManagerFees"
                      className="mb-1 mt-4 text-xs"
                    >
                      <span className="text-labelColour">Swift Code</span>
                    </label>
                    <div className="text-sm">{bank.swift}</div>
                    <div className="flex flex-row gap-2 mt-2 mb-2">
                      {bank.isVerified && (
                        <>
                          <button className="bg-white border-[#75E380] border-2 text-[#75E380] text-xs px-2 py-1 rounded-full flex items-center gap-2">
                            <img
                              src="/valid.svg"
                              alt="Camera Icon"
                              className="w-4 h-4"
                            />
                            Verified
                          </button>
                        </>
                      )}
                      {!bank.isVerified && (
                        <>
                          <button className="bg-white border-[#FF5050] border-2 text-[#FF5050] text-xs px-2 py-1 rounded-full flex items-center gap-2">
                            <img
                              src="/danger.svg"
                              alt="Camera Icon"
                              className="w-4 h-4"
                            />
                            Unverified
                          </button>
                        </>
                      )}
                    </div>
                  </div>

                  {/* Column 2 */}
                  <div className="flex pb-4 flex-col md:px-4 md:pt-6 md:border-l">
                    <label
                      htmlFor="investmentManagerFees"
                      className="mb-1 text-xs text-labelColour"
                    >
                      Branch Identifier{" "}
                    </label>
                    <span className="text-sm">{bank.branch_identifier}</span>
                    {bank.branch_identifier_id == 1 && (
                      <>
                        <label
                          htmlFor="investmentManagerFees"
                          className="mb-1  mt-4  text-xs text-labelColour"
                        >
                          BSB
                        </label>
                        <span className="text-sm">{bank.bsb}</span>
                      </>
                    )}
                    {bank.branch_identifier_id == 2 && (
                      <>
                        <label
                          htmlFor="investmentManagerFees"
                          className="mb-1 mt-4 text-xs text-labelColour"
                        >
                          Country{" "}
                        </label>
                        <span className="text-sm">{bank.country}</span>
                        <label
                          htmlFor="investmentManagerFees"
                          className="mb-1 mt-4 text-xs text-labelColour"
                        >
                          Financial Institution Identifier{" "}
                        </label>
                        <span className="text-sm">{bank.fin_identifier}</span>
                      </>
                    )}
                    {bank.branch_identifier_id == 3 && (
                      <>
                        <label
                          htmlFor="investmentManagerFees"
                          className="mb-1 mt-4 text-xs text-labelColour"
                        >
                          Routing Number{" "}
                        </label>
                        <span className="text-sm">{bank.rountingNumber}</span>
                        <label
                          htmlFor="investmentManagerFees"
                          className="mb-1 mt-4 text-xs text-labelColour"
                        >
                          Payment Method{" "}
                        </label>
                        <span className="text-sm">{bank.paymentMethod}</span>
                        <label
                          htmlFor="investmentManagerFees"
                          className="mb-1 mt-4 text-xs text-labelColour"
                        >
                          ACH Code{" "}
                        </label>
                        <span className="text-sm">{bank.achCode}</span>
                      </>
                    )}
                  </div>

                  {/* Column 3 */}
                  <div className="flex flex-col md:px-4 md:pt-6 md:border-l">
                    <label
                      htmlFor="investmentManagerFees"
                      className="mb-1 text-xs"
                    >
                      <span className="text-labelColour">Currency</span>
                    </label>
                    <div className="text-sm">{bank.currency.name}</div>
                    {(bank.status == "proof_attached" ||
                      bank.status == "approved" ||
                      bank.status == "rejected") && (
                      <div className="mb-2 mt-4">
                        <label
                          htmlFor="investmentType"
                          className="mb-1 text-xs text-labelColour"
                        >
                          Uploaded Docs
                        </label>
                        <div className="mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2">
                          <div className="flex-col flex">
                            <span className="text-black">test.pdf</span>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="flex flex-col md:px-4 md:pt-6 md:border-l">
                    <div className="">
                      <label
                        htmlFor="investmentType"
                        className="mb-1 text-xs text-labelColour"
                      >
                        Address
                      </label>
                      <div className="text-sm">
                        {bank.address_line1 != null ? bank.address_line1 : ""}
                      </div>
                      <div className="text-sm">
                        {bank.address_line2 != null ? bank.address_line2 : ""}
                      </div>
                      <div className="text-sm">
                        {bank.address_line3 != null ? bank.address_line3 : ""}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            {isModalOpen && currentDocument && (
              <DocumentPreview
                fileUrl={currentDocument.name}
                fileName={currentDocument.name}
                onClose={() => setIsModalOpen(false)}
              />
            )}
          </div>
          <div className="bg-white border rounded-md p-4 mt-4">
            <div className="flex flex-col md:flex-row md:items-center justify-between border-colour-custom px-4 py-2 gap-2">
              {/* Left Section */}
              <div className="flex items-center space-x-2">
                <img src="/money-2.svg" alt="Cash Icon" className="h-6 w-6" />
                <h1 className="text-xl font-medium">
                  Cash Account Information
                </h1>
              </div>

              {/* Right Section - Responsive */}
              <div className="flex items-center justify-start md:justify-end gap-x-2 flex-wrap">
                <div className="flex flex-col items-start md:items-end">
                  <span className="text-sm font-semibold text-[#464646] leading-tight">
                    No. Of Cash Account
                  </span>
                </div>
                <span className="text-md font-semibold hidden md:inline">
                  |
                </span>
                <span className="text-sm font-semibold rounded-md text-white py-1 px-3 bg-[#34C046]">
                  {String(accounts.length).padStart(2, "0")}
                </span>
                <img
                  onClick={(e) => {
                    e.preventDefault();
                    setCurrentStep(5);
                  }}
                  src="/edit-details.svg"
                  alt="Edit Icon"
                  className="w-4 h-4 cursor-pointer"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {Array.from({ length: accounts.length }).map((_, index) => (
                <div key={index} className="px-4 py-2">
                  <label
                    htmlFor="advisorRefNumber"
                    className="mb-1 mt-4 text-sm text-labelColour"
                  >
                    Account No.{String(index + 1).padStart(2, "0")}
                  </label>
                  <span className="text-sm">{accounts[index].label}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="bg-white border rounded-md p-4 mt-4">
            <div className="flex justify-between items-start border-colour-custom px-4">
              {/* Left Section: Icon + Heading */}
              <div className="flex items-center space-x-2">
                <img src="/note-2.svg" alt="User Avatar" className="h-6 w-6" />
                <h1 className="text-xl font-medium">Upload Proof Documents</h1>
              </div>

              {/* Right Section: Edit Button */}
              <img
                onClick={(e) => {
                  e.preventDefault();
                  setCurrentStep(6);
                }}
                src="/edit-details.svg"
                alt="Edit Icon"
                className="w-4 h-4 cursor-pointer"
              />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 border-b pb-2">
              {/* first column */}
              <div className="flex flex-col px-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
                <div className="flex items-center justify-between">
                  <label
                    htmlFor="investmentType"
                    className="text-sm text-labelColour  whitespace-normal break-words block"
                  >
                    Contracts with third parties to verify the intended
                    transaction<span className="text-red-500">*</span>
                  </label>
                </div>
                {fileThirdParty && (
                  <div
                    onClick={(e) => {
                      e.preventDefault();
                      handleFileClick(fileThirdParty);
                    }}
                    className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                  >
                    <div className="flex-col flex">
                      <span className="text-black">{fileThirdParty.name}</span>
                    </div>
                  </div>
                )}
              </div>
              {/* second column */}
              <div className="flex flex-col pr-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
                <div className="flex flex-col md:flex-col md:items-left md:justify-between gap-2">
                  <label
                    htmlFor="investmentType"
                    className="labelColour block whitespace-normal break-words text-sm text-labelColour flex items-center"
                  >
                    Details of any current or recent prosecutions and inquiries
                    related to Money Laundering, terrorist links, tax offences
                    and corruption in respect of the Individual
                    <span className="text-red-500">*</span>
                  </label>

                  {/* Radio Buttons */}
                  <div className="flex items-center gap-4 opacity-50 ">
                    <label className="flex items-center text-sm text-black">
                      <input
                        type="radio"
                        name="signatory"
                        value="yes"
                        checked={thirdPartySign === "yes"}
                        className="w-4 h-4 confirm-check  border-gray-300 focus:ring-[#005a9c]"
                      />
                      <span className="ml-2">Yes</span>
                    </label>

                    <label className="flex items-center text-sm text-black">
                      <input
                        type="radio"
                        name="signatory"
                        value="no"
                        checked={thirdPartySign === "no"}
                        className="w-4 h-4 confirm-check  border-gray-300 focus:ring-[#005a9c]"
                      />
                      <span className="ml-2">No</span>
                    </label>
                  </div>
                </div>
                <div className="mt-4">
                  <label
                    htmlFor="description"
                    className="mb-1 text-sm text-labelColour"
                  >
                    Description
                  </label>
                  <span>{description}</span>
                </div>
              </div>
              {/* third column */}
              <div className="flex flex-col pr-4 pt-4">
                <div className="flex items-center justify-between">
                  <label
                    htmlFor="investmentType"
                    className="text-sm text-labelColour  whitespace-normal break-words block"
                  >
                    Upload Proof<span className="text-red-500">*</span>
                  </label>
                </div>
                {fileProof && (
                  <div
                    onClick={(e) => {
                      e.preventDefault();
                      handleFileClick(fileProof);
                    }}
                    className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                  >
                    <div className="flex-col flex">
                      <span className="text-black">{fileProof.name}</span>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 pt-2">
              {/* first column */}
              <div className="flex flex-col pr-4 sm:border-r-0 md:border-r border-gray-300">
                {applicantCountry == 1 && (
                  <>
                    <div className="flex items-center justify-between">
                      <label
                        htmlFor="investmentType"
                        className="text-sm text-labelColour  whitespace-normal break-words block"
                      >
                        Photographic ID<span className="text-red-500">*</span>
                      </label>
                    </div>
                    <span>{photoIdText}</span>

                    {(photoId == 1 || photoId == 3) && (
                      <>
                        <div className="flex items-center justify-between">
                          {photoId == 1 && (
                            <label
                              htmlFor="investmentType"
                              className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                            >
                              Upload Certified Copy of Passport
                              <span className="text-red-500">*</span>
                            </label>
                          )}
                          {photoId == 3 && (
                            <label
                              htmlFor="investmentType"
                              className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                            >
                              Upload Photo ID issued under a State or Territory
                              law
                              <span className="text-red-500">*</span>
                            </label>
                          )}
                        </div>
                        {filePhotographicId && (
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              handleFileClick(filePhotographicId);
                            }}
                            className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                          >
                            <div className="flex-col flex">
                              <span className="text-black">
                                {filePhotographicId.name}
                              </span>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                    {photoId == 2 && (
                      <>
                        <div className="flex items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                          >
                            Upload Certified Copy of Driver's License (Front)
                            <span className="text-red-500">*</span>
                          </label>
                        </div>
                        {fileDriverLinsenceFront && (
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              handleFileClick(fileDriverLinsenceFront);
                            }}
                            className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                          >
                            <div className="flex-col flex">
                              <span className="text-black">
                                {fileDriverLinsenceFront.name}
                              </span>
                            </div>
                          </div>
                        )}
                        <div className="mt-2 flex items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                          >
                            Upload Certified Copy of Driver's License (Back)
                            <span className="text-red-500">*</span>
                          </label>
                        </div>
                        {fileDriverLinsenceBack && (
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              handleFileClick(fileDriverLinsenceBack);
                            }}
                            className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                          >
                            <div className="flex-col flex">
                              <span className="text-black">
                                {fileDriverLinsenceBack.name}
                              </span>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                    <div className="mt-2">
                      <label className="block mb-1 w-full text-sm text-[#464646]">
                        Expiry Date <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="date"
                        value={expiryDate}
                        disabled={true}
                        className="block w-full p-2 text-black font-medium border border-gray-300 rounded-md text-md"
                      />{" "}
                    </div>
                  </>
                )}
                {applicantCountry != 1 && (
                  <>
                    {/* first photo id */}
                    <div className="">
                      <label
                        htmlFor="firstName"
                        className="mb-1 text-sm text-labelColour"
                      >
                        Select First Photographic ID
                      </label>
                      <span>{photoIdFirstText}</span>
                    </div>
                    {(photoIdFirst == 1 || photoIdFirst == 3) && (
                      <>
                        <div className="flex items-center justify-between">
                          {photoIdFirst == 1 && (
                            <label
                              htmlFor="investmentType"
                              className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                            >
                              Upload Notarised Foreign Government Issued
                              Passport <span className="text-red-500">*</span>
                            </label>
                          )}
                          {photoIdFirst == 3 && (
                            <label
                              htmlFor="investmentType"
                              className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                            >
                              Upload Photo ID issued under a State or Territory
                              law
                              <span className="text-red-500">*</span>
                            </label>
                          )}
                        </div>
                        {filePhotographicIdFirst && (
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              handleFileClick(filePhotographicIdFirst);
                            }}
                            className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                          >
                            <div className="flex-col flex">
                              <span className="text-black">
                                {filePhotographicIdFirst.name}
                              </span>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                    {photoIdFirst == 2 && (
                      <>
                        <div className="flex items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                          >
                            Upload Certified Copy of Driver's License (Front)
                            <span className="text-red-500">*</span>
                          </label>
                        </div>
                        {fileDriverLinsenceFrontFirst && (
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              handleFileClick(fileDriverLinsenceFrontFirst);
                            }}
                            className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                          >
                            <div className="flex-col flex">
                              <span className="text-black">
                                {fileDriverLinsenceFrontFirst.name}
                              </span>
                            </div>
                          </div>
                        )}
                        <div className="mt-2 flex items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                          >
                            Upload Certified Copy of Driver's License (Back)
                            <span className="text-red-500">*</span>
                          </label>
                        </div>
                        {fileDriverLinsenceBackFirst && (
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              handleFileClick(fileDriverLinsenceBackFirst);
                            }}
                            className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                          >
                            <div className="flex-col flex">
                              <span className="text-black">
                                {fileDriverLinsenceBackFirst.name}
                              </span>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                    <div className="mt-2">
                      <label className="block mb-1 w-full text-sm text-[#464646]">
                        Expiry Date <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="date"
                        value={expiryDate}
                        disabled={true}
                        className="block w-full p-2 text-black font-medium border border-gray-300 rounded-md text-md"
                      />
                    </div>
                    {/* second photo id */}
                    <div className="">
                      <label
                        htmlFor="firstName"
                        className="mb-1 text-sm text-labelColour"
                      >
                        Select Second Photographic ID
                      </label>
                      <span>{photoIdSecondText}</span>
                    </div>
                    {(photoIdSecond == 1 || photoIdSecond == 3) && (
                      <>
                        <div className="flex items-center justify-between">
                          {photoIdSecond == 1 && (
                            <label
                              htmlFor="investmentType"
                              className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                            >
                              Upload Notarised Foreign Government Issued
                              Passport <span className="text-red-500">*</span>
                            </label>
                          )}
                          {photoIdSecond == 3 && (
                            <label
                              htmlFor="investmentType"
                              className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                            >
                              Upload Photo ID issued under a State or Territory
                              law
                              <span className="text-red-500">*</span>
                            </label>
                          )}
                        </div>
                        {filePhotographicIdSecond && (
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              handleFileClick(filePhotographicIdSecond);
                            }}
                            className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                          >
                            <div className="flex-col flex">
                              <span className="text-black">
                                {filePhotographicIdSecond.name}
                              </span>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                    {photoIdSecond == 2 && (
                      <>
                        <div className="flex items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                          >
                            Upload Certified Copy of Driver's License (Front)
                            <span className="text-red-500">*</span>
                          </label>
                        </div>
                        {fileDriverLinsenceFrontSecond && (
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              handleFileClick(fileDriverLinsenceFrontSecond);
                            }}
                            className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                          >
                            <div className="flex-col flex">
                              <span className="text-black">
                                {fileDriverLinsenceFrontSecond.name}
                              </span>
                            </div>
                          </div>
                        )}
                        <div className="mt-2 flex items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                          >
                            Upload Certified Copy of Driver's License (Back)
                            <span className="text-red-500">*</span>
                          </label>
                        </div>
                        {fileDriverLinsenceBackSecond && (
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              handleFileClick(fileDriverLinsenceBackSecond);
                            }}
                            className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                          >
                            <div className="flex-col flex">
                              <span className="text-black">
                                {fileDriverLinsenceBackSecond.name}
                              </span>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                    <div className="mt-2">
                      <label className="block mb-1 w-full text-sm text-[#464646]">
                        Expiry Date <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="date"
                        value={expiryDateSecond}
                        disabled={true}
                        className="block w-full p-2 text-black font-medium border border-gray-300 rounded-md text-md"
                      />{" "}
                    </div>
                  </>
                )}
              </div>
              {/* second column */}
              <div className="flex flex-col pr-4 sm:border-r-0 md:border-r border-gray-300">
                <label
                  htmlFor="investmentType"
                  className="text-sm text-labelColour  whitespace-normal break-words block"
                >
                  Non Photographic ID<span className="text-red-500">*</span>
                </label>
                <span>{nonphotoIdText}</span>
                <div className="flex items-center justify-between">
                  <label
                    htmlFor="investmentType"
                    className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                  >
                    Upload Document
                    <span className="text-red-500">*</span>
                  </label>
                </div>
                {fileNonPhotographicId && (
                  <div
                    onClick={(e) => {
                      e.preventDefault();
                      handleFileClick(fileNonPhotographicId);
                    }}
                    className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                  >
                    <div className="flex-col flex">
                      <span className="text-black">
                        {fileNonPhotographicId.name}
                      </span>
                    </div>
                  </div>
                )}
              </div>
              {/* third column */}
              <div className="flex flex-col pr-4">
                <div className="">
                  <label
                    htmlFor="investmentType"
                    className="mt-2 text-sm text-[#B2B2B2]  whitespace-normal break-words block"
                  >
                    Personal Details
                    <span className="text-red-500"> *</span>
                  </label>
                </div>
                <span>{personalDataIdText}</span>
                {personalDataId == 1 && (
                  <>
                    <div className="flex mt-2 items-center justify-between">
                      <label
                        htmlFor="investmentType"
                        className="text-sm text-labelColour  whitespace-normal break-words block"
                      >
                        Upload CV<span className="text-red-500">*</span>
                      </label>
                    </div>
                    {fileCV && (
                      <div
                        onClick={(e) => {
                          e.preventDefault();
                          handleFileClick(fileCV);
                        }}
                        className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                      >
                        <div className="flex-col flex">
                          <span className="text-black">{fileCV.name}</span>
                        </div>
                      </div>
                    )}
                  </>
                )}
                {personalDataId == 2 && (
                  <>
                    <label
                      htmlFor="refId"
                      className="mb-1 mt-4 text-sm text-labelColour"
                    >
                      Website Link
                    </label>
                    <span>{webLink}</span>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer className="bottom-actions flex flex-col flex-shrink-0 md:flex-row p-4 bg-[#005A9C]">
        <div className="flex flex-col md:flex-row items-center justify-end w-full space-y-2 md:space-y-0 md:space-x-4 relative">
          {/* Save as Draft */}
          <button
            onClick={() => {
              setIsConfirmWithdraw(true);
            }}
            className="flex w-full md:w-auto items-center justify-center space-x-2 border-2 border-white text-white font-medium py-2 px-4 rounded-full text-sm"
          >
            <span>Withdraw Application</span>
          </button>

          <button
            onClick={() => {
              setIsConfirmSubmit(true);
            }}
            className="flex bg-white w-full md:w-auto items-center justify-center space-x-2 border-2 border-white text-black font-medium py-2 px-4 rounded-full text-sm"
          >
            <span>Submit</span>
          </button>
        </div>
      </footer>
      {isConfirmWithdraw && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div class="bg-white rounded-lg shadow-md w-11/12 max-w-md p-6 text-center">
            <button class="absolute top-3 right-3 text-black text-xl font-bold">
              &times;
            </button>

            <div class="flex justify-center items-center mb-4">
              <div class="flex items-center justify-center">
                <img
                  src="/warning-circle.svg"
                  alt="Add Template Icon"
                  className="h-10 w-10"
                />
              </div>
            </div>

            <h2 class="text-lg font-medium mb-2">
              Are you sure you want to Withdraw Application?
            </h2>
            <p class="text-sm text-black mb-4">
              This will delete all details entered during registration. None of
              the details entered in this form will be saved.
            </p>

            <div class="flex justify-center space-x-4">
              <button
                onClick={() => {
                  setIsConfirmWithdraw(false);
                }}
                class="px-6 py-2 border rounded-full text-black border-black font-medium hover:bg-gray-100"
              >
                No
              </button>
              <button
                onClick={() => {
                  setIsConfirmWithdraw(false);
                  setCurrentStep(1);
                }}
                class="px-6 py-2 bg-black text-white rounded-full font-medium hover:bg-gray-800"
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
      {isConfirmSubmit && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div class="bg-white rounded-lg shadow-md w-11/12 max-w-md p-6 text-center">
            <button class="absolute top-3 right-3 text-black text-xl font-bold">
              &times;
            </button>

            <div class="flex justify-center items-center mb-4">
              <div class="flex items-center justify-center">
                <img
                  src="/tick-circle.svg"
                  alt="Add Template Icon"
                  className="h-10 w-10"
                />
              </div>
            </div>

            <h2 class="text-lg font-medium mb-2">Hi John!</h2>
            <h2 class="text-md font-medium mb-2">
              Individual Application Form has been Submitted Successfully{" "}
            </h2>
            <p class="text-sm text-black mb-4">
              Caprock team will evaluate your application and get back to you
              shortly.
            </p>
            <p class="text-sm text-black mb-4">Thank You. </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReviewSubmit;
